import React from 'react';

const AdGalleryPlaceholder = () => {
  return (
    <div className="placeholder-gallery">
      <div className="placeholder-gallery__thumb-list">
        <div className="placeholder-gallery__thumb animation" />
        <div className="placeholder-gallery__thumb animation" />
      </div>
    </div>
  );
};

export default AdGalleryPlaceholder;
